module.exports = __webpack_public_path__ + "media/images/redesign-images/careers/careers-student-tile-384a767b4e36ac5711491aa5330c7287.jpg";